import { loader } from 'graphql.macro'

export default async function createWastepaySessionToken ({ dataLoaders, variables }) {
  const schema = loader('./createWastepaySessionToken.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { clientId: variables.clientId })
  return response.createWastepaySessionToken
}
